const Coachella = require('../assets/coachella.jpg');
const Lollapalooza = require('../assets/lollapalooza.jpg');
const Glastonbury = require('../assets/glastonbury.jpg');
const Burningman = require('../assets/burningman.jpg');
const Tomorrowland = require('../assets/tomorrowland.jpg');
const SXSW = require('../assets/SXSW.jpg');
const edc = require('../assets/edc.jpeg');
const reading = require('../assets/reading.jpg');
const ultramusicfestival = require('../assets/ultramusicfestival.jpg');
const rockinrio = require('../assets/rockinrio.jpg');

export const musicalEvents = [
  {
    id: 1,
    eventName: 'Coachella',
    eventLocation: 'Indio, California',
    eventDate: 'April 15-17, 2023',
    path: Coachella,
    pricing: 350,
    banner: '',
    helpLine: '1234567890',
    eventDescription:
      'Coachella Valley Music and Arts Festival is a world-renowned music and arts festival featuring a diverse lineup of artists, stunning art installations, and a vibrant atmosphere.',
  },
  {
    id: 2,
    eventName: 'Lollapalooza',
    eventLocation: 'Chicago, Illinois',
    eventDate: 'July 22-24, 2023',
    path: Lollapalooza,
    pricing: 295,
    banner: '',
    helpLine: '1234567890',
    eventDescription:
      'Lollapalooza is an annual music festival known for its diverse lineup, featuring rock, hip-hop, electronic, and more, along with food, art, and fun activities.',
  },
  {
    id: 3,
    eventName: 'Glastonbury Festival',
    eventLocation: 'Pilton, Somerset, UK',
    eventDate: 'June 22-26, 2023',
    path: Glastonbury,
    pricing: 265,
    banner: '',
    helpLine: '1234567890',
    eventDescription:
      "Glastonbury Festival is one of the UK's most iconic music festivals, featuring a wide range of music genres, performing arts, and a vibrant atmosphere.",
  },
  {
    id: 4,
    eventName: 'Burning Man',
    eventLocation: 'Black Rock City, Nevada',
    eventDate: 'August 28-30, 2023',
    path: Burningman,
    pricing: 425,
    banner: '',
    helpLine: '1234567890',
    eventDescription:
      'Burning Man is a unique annual event that combines art, music, and self-expression in the Black Rock Desert, creating an otherworldly experience.',
  },
  {
    id: 5,
    eventName: 'Tomorrowland',
    eventLocation: 'Boom, Belgium',
    eventDate: 'July 21-23, 2023',
    path: Tomorrowland,
    pricing: 375,
    banner: '',
    helpLine: '1234567890',
    eventDescription:
      "Tomorrowland is one of the world's largest electronic dance music festivals, known for its impressive stage designs and top DJ lineups.",
  },
  {
    id: 6,
    eventName: 'SXSW (South by Southwest)',
    eventLocation: 'Austin, Texas',
    eventDate: 'March 10-19, 2023',
    path: SXSW,
    pricing: 225,
    banner: '',
    helpLine: '1234567890',
    eventDescription:
      'SXSW is a multi-faceted event that celebrates music, film, and technology, attracting artists, filmmakers, and tech enthusiasts from around the world.',
  },
  {
    id: 7,
    eventName: 'Electric Daisy Carnival (EDC)',
    eventLocation: 'Las Vegas, Nevada',
    eventDate: 'May 19-21, 2023',
    path: edc,
    pricing: 299,
    banner: '',
    helpLine: '1234567890',
    eventDescription:
      'EDC is a massive electronic dance music festival featuring elaborate stage designs, carnival rides, and a vibrant, immersive atmosphere.',
  },
  {
    id: 8,
    eventName: 'Reading Festival',
    eventLocation: 'Reading, England, UK',
    eventDate: 'August 26-28, 2023',
    path: reading,
    pricing: 210,
    banner: '',
    helpLine: '1234567890',
    eventDescription:
      "Reading Festival is one of the UK's premier rock music festivals, featuring a lineup of rock, alternative, and indie bands, and a great camping experience.",
  },
  {
    id: 9,
    eventName: 'Ultra Music Festival',
    eventLocation: 'Miami, Florida',
    eventDate: 'March 24-26, 2023',
    path: ultramusicfestival,
    pricing: 315,
    banner: '',
    helpLine: '1234567890',
    eventDescription:
      'Ultra Music Festival is a major electronic dance music event held in Miami, known for its high-energy performances and cutting-edge visuals.',
  },
  {
    id: 10,
    eventName: 'Rock in Rio',
    eventLocation: 'Rio de Janeiro, Brazil',
    eventDate: 'September 15-24, 2023',
    path: rockinrio,
    pricing: 280,
    banner: '',
    helpLine: '1234567890',
    eventDescription:
      'Rock in Rio is a legendary music festival featuring a diverse lineup of rock, pop, and other music genres, along with a rich cultural experience.',
  },
];
